import React from 'react';

import SectionScheduleTimeTable from './SectionScheduleTimeTable';

type Props = {
  sectionUsages: any;
};

const timeTable = {
  width: `calc(100% - 60px)`,
  display: 'flex',
  margin: 0,
  padding: 0
};

const ScheduleTimeArea = (props: Props) => {
  const { sectionUsages } = props;

  const sectionList = sectionUsages.sections.map((item: { sectionId: string; sectionName: string }) => ({
    sectionId: item.sectionId,
    sectionName: item.sectionName
  }));

  const startTime = sectionUsages.availableStartTime;
  const endTime = sectionUsages.availableEndTime;

  return (
    <div style={timeTable}>
      {sectionUsages.sections.map((value: any) => (
        <SectionScheduleTimeTable
          section={value.sectionName}
          startTime={startTime.slice(0, 6)}
          endTime={endTime.slice(0, 6)}
          sectionData={value}
          sectionList={sectionList}
          key={`sectionScheduleTimeTable${value.sectionId}${value.date}`}
        />
      ))}
    </div>
  );
};
export default ScheduleTimeArea;
